import React from 'react';
import { Row, Container, Form } from 'reactstrap';
import TableBuilder, { ModalButtonBuilder, RegisteredInputsBuilder, ToastBuilder, ApiRequest } from '../../../../../../../../GlobalComponents/Builders';
import { buildSelectOptionsFromArray } from '../../../../../../../../GlobalComponents/Helpers';
import SectionCard from '../../../../../../../../GlobalComponents/Common/Component/SectionCard';
import { Link } from 'react-router-dom';
import { X } from 'react-feather';

const LinkedJobs = ({
    assessmentId,
    linkedJobs,
    availableJobs,
    register,
    errors,
    control,
    handleSubmit,
    onRefresh,
}) => {

    const handleLinkJob = (formData) => {
        if (!formData.jobToLink) return ToastBuilder('error', 'Select a job');
        ApiRequest('POST', '/dmt/assessments/{assessmentId}/jobs', { pathParams: { assessmentId }, body: { job_id: parseInt(formData.jobToLink) } }).then((res) => {
            if (res.data?.success) {
                ToastBuilder('success', 'Job linked');
                onRefresh();
            }
        });
    };

    const handleUnlinkJob = (jobId) => {
        ApiRequest('DELETE', '/dmt/assessments/{assessmentId}/jobs/{jobId}', { pathParams: { assessmentId, jobId } }).then((res) => {
            if (res.data?.success) {
                ToastBuilder('success', 'Job unlinked');
                onRefresh();
            }
        });
    };

    return (
        <Row>
            <Container>
                <SectionCard title='Linked Jobs' badge={String(linkedJobs.length)} badgeColor='info' defaultOpen={true}
                    actions={
                        <ModalButtonBuilder
                            title='Link Job'
                            className='btn-outline-primary btn-sm'
                            formId='link-job-form'
                            body={
                                <Form id='link-job-form' onSubmit={handleSubmit(handleLinkJob)}>
                                    <RegisteredInputsBuilder
                                        registrator={register}
                                        registratorErrors={errors}
                                        control={control}
                                        inputs={[{
                                            label: 'Job',
                                            name: 'jobToLink',
                                            type: 'reactselect',
                                            labelSize: 3,
                                            required: true,
                                            options: buildSelectOptionsFromArray(
                                                availableJobs.filter((j) => !linkedJobs.some((lj) => lj.id === j.id)),
                                                { label: 'name', value: 'id' }
                                            ),
                                        }]}
                                    />
                                </Form>
                            }
                        />
                    }
                >
                    {linkedJobs.length > 0 ? (
                        <TableBuilder
                            data={linkedJobs}
                            processing={false}
                            pagination={false}
                            title=''
                            columns={[
                                { name: 'Job #', selector: (row) => row.id, sortable: true, center: true, maxWidth: '10%' },
                                {
                                    name: 'Name',
                                    selector: (row) => <Link to={`${process.env.PUBLIC_URL}/tools/data-migration/jobs/${row.id}`}>{row.name}</Link>,
                                    sortable: true, center: true,
                                },
                                { name: 'Type', selector: (row) => row.job_type || '-', sortable: true, center: true, maxWidth: '15%' },
                                { name: 'Production', selector: (row) => row.is_production ? <span style={{ color: 'red' }}>Yes</span> : 'No', center: true, maxWidth: '12%' },
                                {
                                    name: '',
                                    selector: (row) => <X size={16} style={{ cursor: 'pointer', color: 'red' }} onClick={() => handleUnlinkJob(row.id)} title='Unlink job' />,
                                    center: true, maxWidth: '7%',
                                },
                            ]}
                        />
                    ) : <p className='text-muted'>No jobs linked yet. Link a DMT job to associate it with this assessment.</p>}
                </SectionCard>
            </Container>
        </Row>
    );
};

export default LinkedJobs;
